/**
 * Universal Lead Source Normalizer & Display Helper for RS-CRM
 * Handles all possible combinations (casing, spaces, hyphens, abbreviations, aliases).
 */

export const normalizeSourceKey = (source) => {
  if (!source) return "generic";
  const clean = String(source)
    .trim()
    .toLowerCase()
    .replace(/[\s\-]+/g, "_");

  const aliasMap = {
    // RCS combinations
    rcs: "rcs_msg",
    rcs_msg: "rcs_msg",
    rcs_message: "rcs_msg",
    rcsmsg: "rcs_msg",
    rcs_campaign: "rcs_msg",
    rcs_chat: "rcs_msg",
    rcs_sms: "rcs_msg",
    rcs_text: "rcs_msg",

    // AI Calling combinations
    ai: "ai_calling",
    ai_call: "ai_calling",
    ai_calling: "ai_calling",
    aicalling: "ai_calling",
    ai_dialer: "ai_calling",
    ai_bot: "ai_calling",
    ai_agent: "ai_calling",

    // IVR Calling combinations
    ivr: "ivr_calling",
    ivr_call: "ivr_calling",
    ivr_calling: "ivr_calling",
    ivrcalling: "ivr_calling",
    ivr_dialer: "ivr_calling",

    // WhatsApp combinations
    wa: "whatsapp",
    wapp: "whatsapp",
    whatsapp: "whatsapp",
    whats_app: "whatsapp",
    wa_chat: "whatsapp",
    whatsapp_chat: "whatsapp",
    whats_app_chat: "whatsapp",

    // Direct Call combinations
    direct: "direct_call",
    call: "direct_call",
    direct_call: "direct_call",
    phone: "direct_call",
    phone_call: "direct_call",
    inbound_call: "direct_call",
    outbound_call: "direct_call",
    inbound: "direct_call",
    outbound: "direct_call",

    // Walk-in combinations
    walkin: "walk_in",
    walk_in: "walk_in",
    walk_in_client: "walk_in",

    // Referral combinations
    ref: "referral",
    referral: "referral",
    reference: "referral",
    broker: "referral",
    channel_partner: "referral",
    channelpartner: "referral",
    cp: "referral",

    // Manual Entry combinations
    manual: "manual",
    manual_entry: "manual",
    data_entry: "manual",

    // Website combinations
    web: "website",
    site: "website",
    website: "website",
    web_form: "website",
    landing_page: "website",

    // Social combinations
    fb: "facebook",
    facebook: "facebook",
    meta: "facebook",
    fb_ads: "facebook",
    facebook_ads: "facebook",

    google: "google",
    google_ads: "google",
    googleads: "google",
    g_ads: "google",

    // Generic combinations
    generic: "generic",
    generic_lead: "generic",
    import: "generic",
    bulk: "generic",
    bulk_import: "generic",
    excel: "generic",
    excel_import: "generic",
    csv: "generic",
    csv_import: "generic",
    other: "other",
  };

  return aliasMap[clean] || clean;
};

export const SOURCE_CONFIG = {
  rcs_msg: {
    label: "RCS msg",
    icon: "mdi mdi-message-processing",
    color: "info",
    textColor: "text-info",
  },
  ai_calling: {
    label: "Ai calling",
    icon: "mdi mdi-robot",
    color: "primary",
    textColor: "text-primary",
  },
  ivr_calling: {
    label: "Ivr calling",
    icon: "mdi mdi-phone-in-talk",
    color: "warning",
    textColor: "text-warning",
  },
  whatsapp: {
    label: "Whatsapp",
    icon: "mdi mdi-whatsapp",
    color: "success",
    textColor: "text-success",
  },
  direct_call: {
    label: "Direct Call",
    icon: "mdi mdi-phone",
    color: "success",
    textColor: "text-success",
  },
  walk_in: {
    label: "Walk-in",
    icon: "mdi mdi-walk",
    color: "warning",
    textColor: "text-warning",
  },
  referral: {
    label: "Referral",
    icon: "mdi mdi-account-group",
    color: "secondary",
    textColor: "text-secondary",
  },
  website: {
    label: "Website",
    icon: "mdi mdi-web",
    color: "info",
    textColor: "text-info",
  },
  manual: {
    label: "Manual Lead",
    icon: "mdi mdi-account-edit",
    color: "primary",
    textColor: "text-primary",
  },
  facebook: {
    label: "Facebook",
    icon: "mdi mdi-facebook",
    color: "info",
    textColor: "text-info",
  },
  google: {
    label: "Google",
    icon: "mdi mdi-google",
    color: "danger",
    textColor: "text-danger",
  },
  generic: {
    label: "Generic Lead",
    icon: "mdi mdi-account-plus-outline",
    color: "success",
    textColor: "text-success",
  },
  other: {
    label: "Other Lead",
    icon: "mdi mdi-dots-horizontal-circle",
    color: "dark",
    textColor: "text-dark",
  },
};

export const getSourceBadgeInfo = (source) => {
  const canonical = normalizeSourceKey(source);
  if (SOURCE_CONFIG[canonical]) {
    return SOURCE_CONFIG[canonical];
  }
  const prettyLabel = String(source || "generic")
    .trim()
    .replace(/[\s\_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return {
    label: prettyLabel,
    icon: "mdi mdi-account-plus-outline",
    color: "secondary",
    textColor: "text-success",
  };
};
